import { Navigate, Route, Routes } from "react-router-dom";
import ForgotPassword from "../screens/Login/ForgotPassword";
import { ResetPassword } from "../screens/Login/ResetPassword";
import { Login } from "../screens/Login/Login";
import { NotFoundPage } from "../screens/NotFoundPage";
import ProtectedRoute from "./ProtectedRoutes";
import RoleRoute from "./RoleRoutes";
import DashboardView from "../screens/Dashboard/DashboardView";
import ManageCustomers from "../screens/Dashboard/ManageCustomers";
import { EmailNotification } from "../screens/Dashboard/Notifications";
import HrDashboard from "../screens/Dashboard/HR";
import Attendance from "../screens/Dashboard/HR/Attendance";
import Salary from "../screens/Dashboard/HR/Salary";
import EmployeeRegistration from "../screens/Dashboard/HR/Register";
import EmployeesView from "../screens/Dashboard/HR/EmployeeList";
import EmployeeMeetings from "../screens/Dashboard/HR/Meetings";
import Announcements from "../screens/Dashboard/HR/Announcement";
import GenerateLetters from "../screens/Dashboard/HR/Letters";
import TraineeDashboard from "../screens/Dashboard/Trainee";
import { LogOut } from "src/screens/Login/Logout";
import RecruitmentOnboarding from "src/screens/Dashboard/HR/recruitmentOnboarding";
import ComplianceReports from "src/screens/Dashboard/HR/complienceReports";
import PerformanceManagement from "src/screens/Dashboard/HR/performanceManagement";
import PayrollManagement from "src/screens/Dashboard/HR/payroll";
import HRDashboardLayout from "src/components/ui/HRDashboardLayout";
import LeaveManagement from "src/screens/Dashboard/HR/leaveManagement";
import AttendanceHistoryPage from "src/screens/Dashboard/HR/Attendance/AttendanceHistoryPage";
import AttendanceDetails from "src/screens/Dashboard/HR/Attendance/AttendanceDetails";
import Separation from "src/screens/Dashboard/HR/Separation";
import ArchivedList from "src/screens/Dashboard/HR/EmployeeList/ArchivedList";
import UploadPhotos from "../../src/screens/Dashboard/HR/UploadPhotos";
import SupplementLayout from "src/screens/Dashboard/supplements/_layout/supplement_layout";
import Dashboard from "src/screens/Dashboard/supplements/features/dasboard/Dashboard";
import OrdersView from "src/screens/Dashboard/supplements/features/orders/OrdersView";
import InventoryView from "src/screens/Dashboard/supplements/features/inventory/InventoryView";
import NotificationView from "src/screens/Dashboard/supplements/features/notification/NotificationView";
import ImageGalleryView from "src/screens/Dashboard/supplements/features/image_gallery/ImageGalleryView";
import CustomerVerificationPage from "src/screens/Dashboard/supplements/features/orders/CustomerVerificationPage";
import ViewReport from "src/screens/Dashboard/ManageCustomers/view-report";
import AddCounselling from "src/screens/Dashboard/ManageCustomers/add-counselling";
import ViewCounselling from "src/screens/Dashboard/ManageCustomers/view-counselling";
import AddReport from "src/screens/Dashboard/ManageCustomers/add-report";
import CustomerDetails from "src/screens/Dashboard/ManageCustomers/customer-details";
import FrontDeskView from "src/screens/Dashboard/FrontDesk";
import { ViewCandidates } from "src/screens/Dashboard/FrontDesk/ViewCandidates";
import { ViewEbookUsers } from "src/screens/Dashboard/FrontDesk/ViewEbookUsers";
import { ViewEbookUserDetails } from "src/screens/Dashboard/FrontDesk/ViewEbookUserDetails";
import ViewResults from "src/screens/Dashboard/FrontDesk/ViewResults";
import { ViewAdmitCards } from "src/screens/Dashboard/FrontDesk/ViewAdmitCards";
import TasksToday from "src/screens/Dashboard/HR/Attendance/TasksToday";
import SoDashboard from "src/screens/Dashboard/SO";
import Customers from "src/screens/Dashboard/SO/customers";
import InterviewCandidates from "src/screens/Dashboard/webiner";
import Interview from "src/screens/Dashboard/SO/interview";

function AppRoutes() {
  return (
    <Routes>
      {/* public routes */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Login />} />
      <Route path="/logout" element={<LogOut />} />
      <Route
        path="/supplement/orders/customer-info/:orderId"
        element={<CustomerVerificationPage />}
      />
      <Route path="*" element={<NotFoundPage />} />

      {/* protected routes */}
      <Route element={<ProtectedRoute />}>
        {/* admin accessible routes */}
        <Route element={<RoleRoute allowedRoles={["ADMIN", "SO"]} />}>
          <Route path="/admin" element={<DashboardView />} />
          <Route path="/admin/manage-customers" element={<ManageCustomers />} />
          <Route
            path="/admin/manage-customers/details"
            element={<CustomerDetails />}
          />
          <Route
            path="/admin/manage-customers/report/:customerId/:subId/:name"
            element={<AddReport />}
          />
          <Route
            path="/admin/manage-customers/report/view/:customerId/:subId/:name"
            element={<ViewReport />}
          />
          <Route
            path="/admin/manage-customers/counselling/:id"
            element={<AddCounselling />}
          />
          <Route
            path="/admin/manage-customers/counselling/view/:id"
            element={<ViewCounselling />}
          />
          <Route
            path="/admin/self-reset-password"
            element={<ResetPassword />}
          />
          <Route path="/admin/send-email" element={<EmailNotification />} />
          <Route path="/admin/manage-trainees" element={<TraineeDashboard />} />
          <Route
            path="/admin/webiners-candidate"
            element={<InterviewCandidates />}
          />
          <Route path="/upload" element={<UploadPhotos />} />
          <Route path="/notFound" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/admin" />} />
        </Route>

        {/* front desk accessible routes */}
        <Route
          element={<RoleRoute allowedRoles={["FRONT_DESK", "ADMIN", "SO"]} />}
        >
          <Route path="/front-desk" element={<FrontDeskView />} />
          <Route
            path="/front-desk/view-candidates"
            element={<ViewCandidates />}
          />
          <Route
            path="/front-desk/view-ebook-users"
            element={<ViewEbookUsers />}
          />
          <Route
            path="/front-desk/view-ebook-user-details"
            element={<ViewEbookUserDetails />}
          />
          <Route path="/front-desk/view-results" element={<ViewResults />} />
          <Route
            path="/front-desk/view-admit-cards"
            element={<ViewAdmitCards />}
          />
          <Route
            path="/front-desk/send-email"
            element={<EmailNotification />}
          />
          <Route path="/notFound" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/front-desk" />} />
        </Route>

        {/* HR accessible routes */}
        <Route element={<RoleRoute allowedRoles={["HRWO", "ADMIN"]} />}>
          <Route element={<HRDashboardLayout />}>
            <Route path="/hr" element={<HrDashboard />} />
            <Route path="/hr/employees" element={<EmployeesView />} />
            <Route path="/hr/employees/archived" element={<ArchivedList />} />
            <Route path="/hr/attendance" element={<Attendance />} />
            <Route path="/hr/tasks-today" element={<TasksToday />} />
            <Route path="/hr/leave-management" element={<LeaveManagement />} />
            <Route path="/hr/salary" element={<Salary />} />
            <Route path="/hr/register" element={<EmployeeRegistration />} />
            <Route path="/hr/meetings" element={<EmployeeMeetings />} />
            <Route path="/hr/announcements" element={<Announcements />} />
            <Route path="/hr/letters" element={<GenerateLetters />} />
            <Route path="/hr/recruitment" element={<RecruitmentOnboarding />} />
            <Route path="/hr/compliances" element={<ComplianceReports />} />
            <Route path="/hr/performance" element={<PerformanceManagement />} />
            <Route path="/hr/payroll" element={<PayrollManagement />} />
            <Route
              path="/hr/attendance-history"
              element={<AttendanceHistoryPage />}
            />
            <Route
              path="/hr/attendance-history/:empId/:id"
              element={<AttendanceDetails />}
            />
            <Route path="/hr/separation" element={<Separation />} />
          </Route>
          <Route path="/send-email" element={<EmailNotification />} />
          <Route path="/notFound" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/hr" />} />
        </Route>

        {/* Supplement Routes */}
        <Route element={<RoleRoute allowedRoles={["ADMIN", "SO"]} />}>
          <Route element={<SupplementLayout />}>
            <Route path="/supplement" element={<Dashboard />} />
            <Route path="/supplement/orders" element={<OrdersView />} />
            <Route path="/supplement/inventory" element={<InventoryView />} />
            <Route path="/supplement/gallery" element={<ImageGalleryView />} />
            <Route
              path="/supplement/notifications"
              element={<NotificationView />}
            />
          </Route>
        </Route>

        {/* SO accessible routes */}
        <Route element={<RoleRoute allowedRoles={["SO"]} />}>
          <Route path="/so" element={<SoDashboard />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/interview" element={<Interview />} />
          <Route path="/email" element={<EmailNotification />} />
          <Route path="/upload" element={<UploadPhotos />} />
          <Route path="/notFound" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/so" />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
